import { useTranslation } from 'react-i18next'

import Loading from 'components/Loading'
import { DialogContentFailure } from '../../components/DialogContentFailure'
import { DialogContentSuccess } from '../../components/DialogContentSuccess'
import { DropZone } from '../../components/DropZone'
import { DialogConfig, DialogConfigProps } from './types'

export const useDialogConfig = ({
  file,
  hint,
  reset,
  response: { errors, status },
  setFile,
  setOpen,
  upload,
}: DialogConfigProps): DialogConfig => {
  const { t } = useTranslation('features/domain')

  switch (status) {
    case 'failure': {
      if (!file || !errors) throw Error('Uploaded file and errors should be accessible')
      return {
        button: {
          action: reset,
          title: t('form.general.bulkManagement.dialog.changeFile'),
        },
        content: (
          <DialogContentFailure
            errors={errors}
            filename={file.name}
          />
        ),
      }
    }

    case 'initial': {
      return {
        button: {
          action: () => file && upload(file),
          title: t('form.action.upload', { ns: 'common' }),
        },
        content: (
          <DropZone
            file={file}
            hint={hint}
            onChange={setFile}
          />
        ),
      }
    }

    case 'loading': {
      return {
        button: {
          disabled: true,
          title: t('form.action.upload', { ns: 'common' }),
        },
        content: <Loading />,
      }
    }

    case 'success': {
      if (!file) throw Error('Uploaded file should be accessible')
      return {
        button: {
          action: () => setOpen(false),
          title: t('form.action.done', { ns: 'common' }),
        },
        content: <DialogContentSuccess filename={file.name} />,
      }
    }
  }
}
